import { Component } from '@angular/core';

@Component({
  selector: 'app-create-bundle-included-component',
  imports: [],
  templateUrl: './create-bundle-included-component.html',
  styleUrl: './create-bundle-included-component.scss'
})
export class CreateBundleIncludedComponent {

}
